const SiteHeaderSetup = () => {
  const components = document.querySelectorAll('[data-component-site-header]');

  components.forEach((component) => {
    const mainMenuItems = component.querySelectorAll('#menu-hoofdmenu > .menu-item-has-children');
    const subMenuItems = component.querySelectorAll('#menu-hoofdmenu > .menu-item-has-children > .sub-menu');

    const background = component.querySelector('.background');
    const inner = component.querySelector('.inner');
    const primaryNavigation = component.querySelector('.primary-navigation');
    const navigationToggleButton = component.querySelector('.navigation-toggle-button');
    const siteWrapper = document.querySelector('.site-wrapper');

    let isNavigationOpen = false;
    let subMenuHeight = 0;
    let maxNavheight = 1000;
    let navigationWrapperHeight = 0;
    let isMouseInHeader = false;
    let openTween;
    let timeout;
    const switchBetweenMenusDelay = 300;

    let showNavigationTimeline = gsap.timeline();
    let hideNavigationTimeline = gsap.timeline();

    let isDesktopBackgroundVisible = false;

    let isSiteHeaderVisible = true;
    let eventListeners = [];
    let subEventListeners = [];
    let mouseEnterListeners = [];
    let mouseLeaveListeners = [];
    let largeScreenClickEventListeners = [];

    const hideSubmenu = (subMenu, isImmediate = false) => {
      gsap.set(subMenu, {
        css: {
          pointerEvents: 'none',
        },
      });
      gsap.to([subMenu], {
        autoAlpha: 0,
        duration: isImmediate ? 0 : 0.3,
        ease: 'power3.out',
      });
      gsap.to(subMenu.querySelector('.sub-menu-inner'), {
        y: 130,
        duration: isImmediate ? 0 : 0.3,
        ease: 'power3.out',
      });
      collapseBackground(isImmediate);
    };

    const showSubmenu = (subMenu, isImmediate = false) => {
      gsap.set(subMenu, {
        css: {
          pointerEvents: 'auto',
        },
      });
      gsap.to(subMenu, {
        autoAlpha: 1,
        duration: isImmediate ? 0 : 0.3,
        ease: 'power3.out',
      });
      gsap.to(subMenu.querySelector('.sub-menu-inner'), {
        y: 0,
        duration: isImmediate ? 0 : 0.3,
        ease: 'power3.out',
      });
      expandBackground();
    };

    const expandBackground = () => {
      component.classList.add('sub-menu-open');
      openTween = gsap.to(inner, {
        height: navigationWrapperHeight + subMenuHeight + maxNavheight - primaryNavigation.offsetTop,
        duration: 0.5,
        ease: 'power3.out',
      });
      gsap.to([background], {
        autoAlpha: 1,
        duration: 0.5,
        ease: 'power3.out',
      });
    };

    const collapseBackground = (isImmediate = false) => {
      openTween = null;
      const collapse = () => {
        component.classList.remove('sub-menu-open');
        gsap.to(inner, {
          height: 'auto',
          duration: isImmediate ? 0 : 0.5,
          ease: 'power3.out',
        });
        gsap.to([background], {
          autoAlpha: 0,
          duration: isImmediate ? 0 : 0.5,
          ease: 'power3.out',
          onComplete: () => {
            isDesktopBackgroundVisible = false;
          }
        });
      };
      if (isImmediate) {
        collapse();
      } else {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
          if (!openTween) {
            collapse();
          }
        }, switchBetweenMenusDelay);
      }

    };

    const showSiteHeader = (immediate = false) => {
      gsap.to(component, {
        yPercent: 0,
        duration: immediate ? 0 : 0.7,
        ease: 'power3.out',
      });
    };

    const hideSiteHeader = (immediate = false) => {
      gsap.to(component, {
        yPercent: -100,
        duration: immediate ? 0 : 0.7,
        ease: 'power3.out',
      });
    };

    const handleHeaderPosition = (currentScrollTop) => {
      if (isNavigationOpen) return;
      if (currentScrollTop > 300) {
        if(isSiteHeaderVisible && !component.classList.contains('is-scroll-header')) {
          component.classList.add('is-scroll-header');
          hideSiteHeader(true);
          isSiteHeaderVisible = false;
        }

        if (isScrollingUp) {
          if(!isSiteHeaderVisible) showSiteHeader();
          isSiteHeaderVisible =  true;

        } else {
            if(isSiteHeaderVisible) hideSiteHeader();
            isSiteHeaderVisible = false;
        }
      } else {
        if (currentScrollTop === 0) {
          showSiteHeader(true);
          component.classList.remove('is-scroll-header');
        }
      }
    };

    const showSiteNavigation = (isImmediate = false) => {
      navigationToggleButton.classList.add('is-active');
      isNavigationOpen = true;
      if (hideNavigationTimeline) hideNavigationTimeline.kill();
      showNavigationTimeline = gsap.timeline();
      showNavigationTimeline.to(primaryNavigation, {
        xPercent: 0,
        duration: isImmediate ? 0 : 0.5,
        ease: 'power3.out'
      });
    };

    const hideSiteNavigation = (isImmediate = false) => {
      navigationToggleButton.classList.remove('is-active');
      isNavigationOpen = false;
      if (showNavigationTimeline) showNavigationTimeline.kill();
      hideNavigationTimeline = gsap.timeline();
      hideNavigationTimeline.to(primaryNavigation, {
        xPercent: 100,
        duration: isImmediate ? 0 : 0.5,
        ease: 'power3.out'
      });
    };

    const collapseSubMenu = (item, isImmediate = false) => {
      item.classList.remove('is-open');
      gsap.to(item.querySelector('.sub-menu'), {
        height: 0,
        ease: 'power3.out',
        duration: isImmediate ? 0 : 0.5,
      });
    };

    const expandSubMenu = (item) => {
      item.classList.add('is-open');
      gsap.to(item.querySelector('.sub-menu'), {
        height: 'auto',
        ease: 'power3.out',
        duration: 0.5,
      });
    };

    const handleSmallScreenItemClick = (item, index) => {
      event.preventDefault();
      mainMenuItems.forEach((otherItem, otherIndex) => {
        if (index !== otherIndex) collapseSubMenu(otherItem);
      });
      if(item.classList.contains('is-open')) {
        collapseSubMenu(item);
      } else {
        expandSubMenu(item);
      }
    };

    const handleSmallScreenSubItemClick = (item, index) => {
      const mainMenuItemsWithSubMenus = item.querySelectorAll('.menu-item-has-children');
      event.preventDefault();
      mainMenuItemsWithSubMenus.forEach((otherItem, otherIndex) => {
        if (index !== otherIndex) collapseSubMenu(otherItem);
      });
      if(item.classList.contains('is-open')) {
        collapseSubMenu(item);
      } else {
        expandSubMenu(item);
      }
    };

    const handleLargeScreenItemClick = (event) => {
      event.preventDefault();
    };

    const cleanSmallScreen = () => {
      showSiteNavigation(true);
      mainMenuItems.forEach((item) => {
        expandSubMenu(item, true);
      });

      mainMenuItems.forEach((item, index) => {
        const link = item.querySelector('a');
        link.removeEventListener('click', eventListeners[index]);
        const mainMenuItemsWithSubMenus = item.querySelectorAll('.menu-item-has-children');
        mainMenuItemsWithSubMenus.forEach((subItem, subIndex) => {
          const subLink = subItem.querySelector('a');
          subLink.removeEventListener('click', subEventListeners[subIndex]);
        });

      });
    };


    const setupSmallScreen = () => {
      eventListeners = [];
      subEventListeners = [];
      hideSiteNavigation(true);
      mainMenuItems.forEach((item) => {
        collapseSubMenu(item, true);
      });

      mainMenuItems.forEach((item, index) => {
        const link = item.querySelector('a');
        const clickListener = handleSmallScreenItemClick.bind(event, item, index);
        eventListeners.push(clickListener);
        link.addEventListener('click', clickListener);

        const mainMenuItemsWithSubMenus = item.querySelectorAll('.menu-item-has-children');

        mainMenuItemsWithSubMenus.forEach((subItem, index) => {
          const subLink = subItem.querySelector('a');
          const subClickListener = handleSmallScreenSubItemClick.bind(event, subItem, index);
          subEventListeners.push(subClickListener);
          subLink.addEventListener('click', subClickListener);
        });

      });
    };

    const handleMouseEnterHeader = () => {
      isMouseInHeader = true;
    };

    const handleMouseLeaveHeader = () => {
      isMouseInHeader = false;
    };

    const handleMouseEnterItem = (item) => {
      const subMenu = item.querySelector('.sub-menu');
      showSubmenu(subMenu);
    };

    const handleMouseLeaveItem = (item) => {
      const subMenu = item.querySelector('.sub-menu');
      hideSubmenu(subMenu);
    };

    const cleanLargeScreen = () => {
      mainMenuItems.forEach((item) => {
        const subMenu = item.querySelector('.sub-menu');
        showSubmenu(subMenu, true);
      });
      component.removeEventListener('mouseenter', handleMouseEnterHeader);
      component.removeEventListener('mouseleave', handleMouseLeaveHeader);
      mainMenuItems.forEach((item, index) => {
        item.removeEventListener('mouseenter', mouseEnterListeners[index]);
        item.removeEventListener('mouseleave', mouseLeaveListeners[index]);
        if (isTouchDevice) {
          item.querySelector('a').removeEventListener('click', largeScreenClickEventListeners[index]);
        }
      });
    };

    const setupLargeScreen = () => {
      mouseEnterListeners = [];
      mouseLeaveListeners = [];
      largeScreenClickEventListeners = [];
      component.addEventListener('mouseenter', handleMouseEnterHeader);
      component.addEventListener('mouseleave', handleMouseLeaveHeader);

      mainMenuItems.forEach((item, index) => {
        const mouseEnterListener = handleMouseEnterItem.bind(event, item);
        const mouseLeaveListener = handleMouseLeaveItem.bind(event, item);

        mouseEnterListeners.push(mouseEnterListener);
        mouseLeaveListeners.push(mouseLeaveListener);
        item.addEventListener('mouseenter', mouseEnterListener);
        item.addEventListener('mouseleave', mouseLeaveListener);
        if (isTouchDevice) {
          const clickEventListener = handleLargeScreenItemClick.bind(event, item);
          largeScreenClickEventListeners.push(clickEventListener);
          item.querySelector('a').addEventListener('click', handleLargeScreenItemClick);
        }
      });
    };

    let isLargeScreenSetup = false;
    let isSmallScreenSetup = false;


    const handleWindowResize = () => {
      siteWrapper.style.paddingTop = `${component.querySelector('.navigation-wrapper').offsetHeight}px`;

      if (window.innerWidth < 1024) {
        if (isLargeScreenSetup) cleanLargeScreen();
        if (!isSmallScreenSetup) setupSmallScreen();
        isSmallScreenSetup = true;
        isLargeScreenSetup = false;
      } else {
        if (isSmallScreenSetup) cleanSmallScreen();
        if (!isLargeScreenSetup) setupLargeScreen();
        subMenuItems.forEach((subMenu) => {
          hideSubmenu(subMenu, true);
        });
        isLargeScreenSetup = true;
        isSmallScreenSetup = false;
        setTimeout(() => {
          subMenuHeight = 0;
          navigationWrapperHeight = 0;
          subMenuItems.forEach((subMenu) => {
            if (subMenu.offsetHeight > subMenuHeight) subMenuHeight = subMenu.offsetHeight;
          });
          navigationWrapperHeight = component.querySelector('.navigation-wrapper').offsetHeight;
        }, 300);
      }
    };

    handleWindowResize();

    window.addEventListener('resize', () => handleWindowResize());

    navigationToggleButton.addEventListener('click',  () => {
      if (navigationToggleButton.classList.contains('is-active')) {
        hideSiteNavigation();
      } else {
        showSiteNavigation();
      }
    });

    const searchForm = document.querySelector('[data-component-search-form]');
    const searchToggles = component.querySelectorAll('.search-toggle');

    const search = searchForm.querySelector('.search');
    const wrapper = searchForm.querySelector('.wrapper');
    const searchBackground = searchForm.querySelector('.background');
    const searchInput = searchForm.querySelector('.input');

    let isSearchActive = false;

    searchToggles.forEach((searchToggle) => {
      searchToggle.addEventListener('click', () => {
        if(isSearchActive) {
          hideSearch();
          isSearchActive = false;
        } else {
          showSearch();
          isSearchActive = true;
        }
      });
    });

    searchBackground.addEventListener('click', () => {
      hideSearch();
      isSearchActive = false;
    });

    const showSearch = () => {
      const timeline = gsap.timeline({ onComplete: () => searchInput.focus()});
      timeline.fromTo(wrapper, {
        autoAlpha: 0,
      }, {
        autoAlpha: 1,
        ease: 'power3.out',
        duration: 0.3,
      });
      timeline.fromTo(search, {
        y: -20,
      }, {
        y: 0,
        duration: 0.5,
        ease: 'power3.out',
      }, 0);
    };

    const hideSearch = (isImmediate = false) => {
      const timeline = gsap.timeline();
      timeline.to(search, {
        ease: 'power3.out',
        duration: 0.3,
        y: 20,
      });
      timeline.to(wrapper, {
        autoAlpha: 0,
        ease: 'power3.out',
        duration: 0.3,
      }, 0);
      if (isImmediate) timeline.progress(1);
    };

    hideSearch(true);

    window.addEventListener('scroll', () => {
      handleHeaderPosition(currentScrollTop);
    });
  });
};
SiteHeaderSetup();